import { Ng1StateDeclaration } from '@uirouter/angularjs';

import * as Resolve from '../Resolve';
import { Roles } from '../../common/constants';

const states: Ng1StateDeclaration[] = [
    {
        name: 'themeChecker',
        url: '/themeChecker',
        component: 'wtThemeCheckerState',
        resolve: {
            auth: Resolve.authResolve,
            roles: Resolve.rolesResolve([Roles.superAdministrator])
        },
        data: {
            visible: false,
            sortingOrder: 199,
            icon: 'fa-paint-brush',
            displayName: 'Theme Checker',
            editButtonVisibility: () => false,
        }
    }];

export default states;